export default __webpack_public_path__ + "5a5815a4cd2856ab283ff39d15b93073.png";